import dedupList from '../../utils/dedupeList'
import mapEvent from './mapEvent'

function getStateOptions(enableDataLabels, stateJson,dashboardType) {
  return {
    //borderColor: 'gray',
    borderWidth: 1,
    mapData: stateJson,
    name: 'US RSV Incidence',
    joinBy: ['hc-a2', 'state'],
    animation: false,
    cursor: 'pointer',
    allowPointSelect: dashboardType!=='meningitis'?true:false,
    states: {
      hover: {
        brightness:0
      },
    },
    dataLabels: {
      enabled: enableDataLabels,
      formatter: function () {
        return (
          '<div style="border:solid 1px;color:black;padding:0.5em;text-align:center;font-size: 12px;background: #FAE0DA;text-shadow: 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.3em white, 0 0 0.4em white;">' +
          this.point.geo_id +
          '</div>'
        )
      },
    },
  }
}
function getZip3Options(activeZip3, enableDataLabels, zip3Json, zoomLocation) {
  let filteredFeats = []
  zip3Json.features.forEach((feat) => {
    activeZip3.includes(feat.properties.geoid)
    if (activeZip3.includes(feat.properties.geoid)) {
      filteredFeats.push(feat)
    }
  })

  zip3Json.features = filteredFeats

  return {
    //borderColor: 'gray',
    borderWidth: 1,
    mapData: zip3Json,
    name: 'US Flu Incidence',
    joinBy: ['geoid', 'geo_id'],
    animation: false,
    cursor: 'pointer',
    allowPointSelect: true,
    enabled: enableDataLabels,
    states: {
      hover: {
        brightness:0
      },
    },
    dataLabels: {
      enabled: enableDataLabels,
      formatter: function () {
        var value =
          parseInt(zoomLocation) === parseInt(this.point.geo_id)
            ? this.point.geo_id
            : ''
        return (
          '<div style="border:solid 1px;color:black;padding:0.5em;text-align:center;font-size: 12px;background: #FAE0DA;text-shadow: 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.3em white, 0 0 0.4em white;">' +
          value +
          '</div>'
        )
      },
    },
  }
}

function getCbsaOptions(activeCbsas, showCbsaLabels, getJsonData, highlight) {
  let filteredFeats = []
  getJsonData.features.forEach((feat) => {
    activeCbsas.includes(feat.properties.geoid)
    if (activeCbsas.includes(feat.properties.geoid)) {
      filteredFeats.push(feat)
    }
  })

  getJsonData.features = filteredFeats

  return {
    borderColor: 'gray',
    borderWidth: highlight ? 2.1 : 1,
    mapData: getJsonData,
    name: 'Infection rate',
    dataLabels: {
      enabled: showCbsaLabels,
      formatter: function () {
        return (
          '<div style="border:solid 1px;color:black;padding:0.5em;text-align:center;font-size: 12px;background: #FAE0DA;text-shadow: 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.3em white, 0 0 0.4em white;">' +
          this.point.geo_name +
          '</div>'
        )
        // return `<div style="font-size:14px;font-weight: 700;color:#000000; text-shadow: 0 0 3px #FFFFFF, 0 0 5px #FFFFFF;">
        //   ${this.point.geo_name}
        //   </div>`
      },
    },
    joinBy: ['geoid', 'state'],
    animation: false,
    cursor: 'pointer',
    allowPointSelect: true,
    states: {
      hover: {
        brightness:0
      },
    },
  }
}

function getCountyOptions(
  activeCounties,
  showCountyLabels = false,
  countyJsonData,
  zoomLocation
) {
  let filteredFeats = []
  countyJsonData.features.forEach((feat) => {
    activeCounties.includes(feat.properties.geoid)
    if (activeCounties.includes(feat.properties.geoid)) {
      filteredFeats.push(feat)
    }
  })

  countyJsonData.features = filteredFeats

  return {
    //borderColor: 'gray',
    borderWidth: 1,
    mapData: countyJsonData,
    name: 'US Flu Incidence',
    joinBy: ['geoid', 'geo_id'],
    animation: false,
    cursor: 'pointer',
    allowPointSelect: true,
    enabled: showCountyLabels,
    states: {
      hover: {
        brightness:0
      },
    },
    dataLabels: {
      enabled: showCountyLabels,
      formatter: function () {
        var value =
          parseInt(zoomLocation) === parseInt(this.point.geo_id)
            ? this.point.geo_name
            : ''
        return (
          '<div style="border:solid 1px;color:black;padding:0.5em;text-align:center;font-size: 12px;background: #FAE0DA;text-shadow: 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.2em white, 0 0 0.3em white, 0 0 0.4em white;">' +
          value +
          '</div>'
        )
      },
    },
  }
}

function getMapOptions(
  colorAxis,
  legend,
  toolTipFormatter,
  activeCbsasData,
  cbsaData,
  stateData,
  msaData,
  history,
  mapType,
  enableButtons,
  zoomLocation,
  mapDataType,
  JsonData,
  stateJson,
  countyData,
  countyGeoJson,
  dashboardType,
  titleText = null,
  subtitleText = null,
  showStateLabels = true,
  showCbsaLabels = false,
  enableTooltip = true,
  enableMapNavigation = true,
  enableMouseTracking = true,
  zip3Json,
  zip3DataFiltered,
  mapActiveZIP3Data,
  highlightCBSA,
  exportMap = false,
  enableMouseZoom = false,
  showCountyLabels = false,
  showZip3Labels = true,
  showCountyBorder = true,

  
) {
  let getMapState=false
  let cbsaOptions = {}
  let stateOptions = {}
  let zip3Options = {}
  let countyOptions = {}

  if (cbsaData === null) {
    cbsaOptions.visible = false // = {}
  } else {
    cbsaOptions = getCbsaOptions(
      activeCbsasData,
      showCbsaLabels,
      JsonData,
      highlightCBSA
    )
    cbsaOptions.visible = true
    cbsaOptions.data = dedupList(cbsaData)
  }
  if (stateData === null) {
    stateOptions.visible = false // = {}
  } else {
    stateOptions = getStateOptions(showStateLabels, stateJson,dashboardType)
    stateOptions.visible = true
    stateOptions.data = dedupList(stateData)
  }
  if (zip3DataFiltered === null) {
    zip3Options.visible = false
  } else {
    zip3Options = getZip3Options(
      mapActiveZIP3Data,
      showZip3Labels,
      zip3Json,
      zoomLocation
    )
    zip3Options.visible = true
    zip3Options.data = zip3DataFiltered
  }
  if (countyData===null) {
    countyOptions.visible = false
  } else {
    countyOptions = getCountyOptions(
      mapActiveZIP3Data,
      showCountyLabels,
      countyGeoJson,
      zoomLocation
    )
    countyOptions.visible = showCountyBorder
    countyOptions.data =dedupList(countyData) 
  }

  return {
    title: {
      text: titleText,
      style: {
        fontWeight: '700',
        fontsize: '8px',
      },
     
    },
    subtitle: {
      text: subtitleText,
    },
    chart: {
      displayErrors: false,
      events: {
        load: function () {
          let point = this.series[mapDataType].points.find(function (p) {
            return p.state !== undefined && p.state.toLowerCase() === zoomLocation.toLowerCase()
          })
          if (point !== null && point !== undefined) {
            point.state !== null && point.zoomTo()
          }
        },
      },
    },

    colorAxis: colorAxis,
    legend: legend,
    series: [stateOptions, cbsaOptions, zip3Options, countyOptions],
    mapNavigation: {
      //enabled: enableMapNavigation,
      enableButtons:true,
      enableMouseWheelZoom: enableMouseZoom,
      enableButtons: enableButtons,
      buttonOptions: {
        verticalAlign: 'bottom',
        align: 'right',
        style: {
          fontSize: '20px',
          fontWeight: 'bold',
          color: '#0C55B8',
          backgroundColor: '#FFFFFF',
        },
      },
    },
      tooltip: {
        enabled: enableTooltip,
        formatter: toolTipFormatter,
        
        borderRadius: 10,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        useHTML: true,
        outside: true,
        style: {
          padding: 0,
        },
      
      },
    exporting: {
      enabled: exportMap,
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      series: {
        
        dataLabels: {
          allowOverlap: true,
        },
        stickyTracking: true,
        point: {
          events: {
            
            }					
          
        }
      },
      map: {
        enableMouseTracking: enableMouseTracking,
        point: {
          events: {
            select: function () {
              mapEvent(mapType, this.options, history, dashboardType)
              return false
            },
            unselect: function () {},
          },
        },
      },
    },
  }
}

export default getMapOptions
